'use client';

export { default } from './Alert';
export { default as alertClasses } from './alertClasses';
export * from './alertClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Alert/index.js
// module id = 881
// module chunks = 25